import { USUARIOS_PORTAL_PROPERTIES_QUERY } from '../data/usuarios-portal-properties'
import { OptionSelect } from '@/core/utils/types'
import { UsuariosPortalPropertiesQueryQuery } from '@/core/types/graphql'
import { useQuery } from '@tanstack/react-query'
import { request } from '../../../core/utils/request'

export const useUsuariosPortalProperties = () => {
  const { data } = useQuery({
    queryKey: ['usuariosPortalProperties'],
    queryFn: async () =>
      await request<UsuariosPortalPropertiesQueryQuery>(
        USUARIOS_PORTAL_PROPERTIES_QUERY
      ),
    staleTime: 0,
    refetchOnMount: 'always'
  })

  const tiposUsuarioInformarCargo: UsuariosPortalPropertiesQueryQuery['usuariosPortalProperties']['tiposUsuarioInformarCargo'] =
    data?.usuariosPortalProperties?.tiposUsuarioInformarCargo ?? []

  const tiposUsuarioInformarGestao: UsuariosPortalPropertiesQueryQuery['usuariosPortalProperties']['tiposUsuarioInformarGestao'] =
    data?.usuariosPortalProperties?.tiposUsuarioInformarGestao ?? []

  const isInformarCargo = (tipo: OptionSelect) => {
    return tiposUsuarioInformarCargo.some(tu => tu?.id === tipo.value)
  }

  const isInformarGestao = (tipo: OptionSelect) => {
    return tiposUsuarioInformarGestao.some(tu => tu?.id === tipo.value)
  }

  const isInformarDesligamento = (tipo: string) => {
    return tiposUsuarioInformarGestao.some(tu => tu?.id === tipo)
  }

  const isInformarDepartamentoCargo: boolean =
    data?.usuariosPortalProperties?.informarDepartamentoCargo ?? false

  return {
    isInformarCargo,
    isInformarGestao,
    isInformarDepartamentoCargo,
    isInformarDesligamento
  }
}
